import { Spin, Skeleton } from '@bfe/moly';
import cls from 'classnames';

import styles from './index.module.scss';

export const PageSkeleton = () => {
  return (
    <>
      <div className={styles.h5}>
        <Spin theme="dark">
          <div className="w-full h-screen" />
        </Spin>
      </div>
      <div className={styles.pc}>
        <div className={styles.inner}>
          <div className={styles.banner}>
            <div className={styles.main}>
              <Skeleton.Bar
                style={{
                  width: 600,
                  height: 36,
                  marginTop: 3,
                }}
              />
              <Skeleton.Bar
                style={{
                  width: 400,
                  height: 20,
                  marginTop: 11,
                }}
              />
              <Skeleton.Bar
                style={{
                  width: 300,
                  height: 20,
                  marginTop: 8,
                }}
              />
              <Skeleton.Bar
                style={{
                  width: 800,
                  height: 16,
                  marginTop: 28,
                }}
              />
              <Skeleton.Bar
                style={{
                  width: 800,
                  height: 16,
                  marginTop: 8,
                }}
              />
            </div>
            <div className={styles.extra}>
              <Skeleton.Bar
                style={{
                  width: 120,
                  height: 16,
                  marginTop: 4,
                }}
              />
              <Skeleton.Bar
                style={{
                  width: 240,
                  height: 111,
                  marginTop: 40,
                }}
              />
            </div>
          </div>
          <Skeleton.Bar
            style={{
              width: 1200,
              height: 128,
              marginTop: 48,
            }}
          />
          <Skeleton.Bar
            style={{
              width: 1200,
              height: 360,
              marginTop: 40,
            }}
          />
          {/* <div className={styles.loading}>
            <Spin theme="dark" />
          </div> */}
        </div>
      </div>
    </>
  );
};
